module.exports = __webpack_public_path__ + "static/media/popupConfirm.94fd8cc9.svg";